module.exports = __webpack_public_path__ + "static/img/invite.7d84082f.png";